<script>
import { customerMethods } from '@state/helpers'
import liveChat from '@components/live-chat'
export default {
  components: { liveChat },
  props: {
    product: {
      type: Object,
      default: () => undefined,
    },
    voucherEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cartError: null,
      productAvailable: false,
    }
  },
  methods: {
    ...customerMethods,
    showModal() {
      this.$refs.taxesModal.show()
    },
  },
}
</script>

<template>
  <div v-if="product" class="cart">
    <div :class="$style.product">
      <div :class="$style.header">
        <h3>You Selected</h3>
      </div>
      <img :src="product.image" />
      <p class="text-center">{{ product.name }}</p>
      <h3 class="text-center">${{ product.price }}</h3>
    </div>
    <div v-if="product" :class="$style.product">
      <div :class="$style.header">
        <h3>Summary</h3>
      </div>
      <div class="row ml-0 mr-0 pt-2 pb-2" :class="$style.prices">
        <div class="col-7">
          <strong>Subtotal</strong>
        </div>
        <div class="col-5">
          <strong>${{ product.price }}</strong>
        </div>
      </div>
      <div class="row ml-0 mr-0 pb-2">
        <div class="col-7">
          <strong>Delivery</strong>
        </div>
        <div class="col-5">
          <strong>FREE</strong>
        </div>
      </div>
      <div
        v-if="voucherEnabled"
        :class="$style.discount"
        class="row ml-0 mr-0 pb-2"
      >
        <div class="col-7">
          <strong>Discount:</strong>
        </div>
        <div class="col-5">
          <strong>-${{ product.price }}</strong>
        </div>
      </div>
      <div class="row ml-0 mr-0 pb-2">
        <div class="col-7">
          <strong>Local Sales Tax</strong>
        </div>
        <div class="col-5">
          <strong>
            <span class="clickLink p-0" @click="showModal">TBD</span>
          </strong>

          <b-modal
            ref="taxesModal"
            hide-footer
            centered
            title="Local Sales Tax"
          >
            <div class="d-block">
              <p>
                Local sales tax will be applied to orders placed within AL, AZ,
                CO, DC, HI, IA, IL, MD, NJ, NM, NY, OH, SC, SD, TX, WA, WI, WV,
                and PR
              </p>
            </div>
          </b-modal>
        </div>
      </div>
    </div>
    <div class="row" style="display: none;">
      <div class="col-12">
        <liveChat class="mt-4" :is-link="false" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.product {
  margin-bottom: 15px;
  border: 1px solid #f2f2f2;
  p {
    margin: 0;
  }
  h3 {
    padding: 0 15px;
    margin: 0;
  }
  img {
    width: 100%;
    height: auto;
    padding: 0 25px;
  }
  .header {
    padding: 10px 0px;
    background-color: #f2f2f2;
  }
  strong {
    font-size: 14px;
  }
}
.discount {
  color: #b95859;
}
</style>
